/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import './VMNManagement.css';
import VMNAllot from './VMNAllot';
import VMNAllotPremium from './VMNAllotPremium';
import UpdateCategoryPrice from './UpdateCategoryPrice';
import SearchAvailableNumbers from './SearchAvailableNumbers';
import ReleaseVMNs from './ReleaseVMNs';
// import CentralVMNUpload from './CentralVMNUpload';
// import AlohaaVMNUpload from './AlohaaVMNUpload';
import {
  sess_get,
} from '../../../utils/HttpRequests';

const VMNManagement = () => {
  const [detail, setDetail] = useState({});
  const [error, setError] = useState('');
  const getAllPrices = async () => {
    try {
      const sessionToken = localStorage.getItem('admin-panel-sessionToken');
      const prices = await sess_get('admin/console/prices', sessionToken);
      const {
        is_premium_avail,
        is_vip_avail,
        premium_price,
        similar_price,
        vip_price,
      } = prices.data.response;
      setDetail({
        is_premium_avail,
        is_vip_avail,
        premium_price,
        similar_price,
        vip_price,
      });
    } catch (err) {
      setError(err.message || 'something went wrong in getAllPrices');
    }
  };

  useEffect(() => {
    getAllPrices();
  }, []);
  return (
    <div>
      <VMNAllot />
      <VMNAllotPremium detail={detail} />
      <UpdateCategoryPrice error={error} detail={detail} getAllPrices={getAllPrices} />
      {/* <CentralVMNUpload /> */}
      {/* <AlohaaVMNUpload /> */}
      <SearchAvailableNumbers />
      <ReleaseVMNs />
    </div>
  );
};

export default VMNManagement;
